<template>
	<div class="slider-water">
		<div ref="slider" :style="sliderStyles" class="slider-anchor"></div>

		<div class="presets">
			<div class="preset text-tiny" style="left:40%;">
				<span>ASHRAE Low</span>
			</div>

			<div class="preset larger text-tiny" style="left:50%;">
				<span>Ecotope Market Rate with Low Flow Fixtures</span>
			</div>

			<div class="preset text-tiny"  style="left:100%; z-index: 3;">
				<span>ASHRAE Medium</span>
			</div>
		</div>
	</div>
</template>

<script>
import noUiSlider from 'nouislider'

export default {
	name: 'WaterSlider',

	props: {
		sliderStyles: {
			type: Object,
			default: () => ({}),
		},
		label: String,
		onUpdate: Function,
		value: {
			type: Number,
			default: 25,
		},
	},

	mounted () {
		const { $refs: { slider }, value, onUpdate } = this
		const min = 1
		const max = 49

		noUiSlider.create(slider, {
			range: { min, max },
			step: 1,
			start: [value],
			// Display colored bars between handles
			connect: [true, false],
			behaviour: 'tap-drag',
			tooltips: true,
			pips: {
				mode: 'values',
				values: [min, max],
				// (legacy filter notes) "make value large size" or "no pip"
				filter: val => [min, max].includes(val) ? 1 : -1
			},
			format: {
				to: Math.floor,
				from: Math.floor,
			}
		})

		slider.noUiSlider.on('update', ([val]) => onUpdate(val))
	},

	watch: {
		value (newVal) {
			const { $refs: { slider } } = this

			if (newVal != slider.noUiSlider.get()) {
				slider.noUiSlider.set(newVal)
			}
		}
	}
}
</script>

<style scoped>
	.slider-anchor {
		z-index: 2;
	}

	.presets {
		position: absolute;
		width: 100%;
		top: 49%;
	}
</style>
